/* eslint-env jquery */

"use strict";

function initSwipers() {
    const Swiper = require("swiper").default;
    const Navigation = require("swiper").Navigation;
    const Pagination = require("swiper").Pagination;
    const Scrollbar = require("swiper").Scrollbar;
    const Thumbs = require("swiper").Thumbs;

    const initializedAttr = "data-swiper-initialized";

    const configs = [
        {
            selector: ".js-swiper-carousel",
            getWrapperClass: ($el) => `.js-swiper-carousel[data-id="${$el.data("id")}"]`,
            getContainerSelector: (wrapperClass) => `${wrapperClass} .js-swiper-container`,
            afterInit: null
        },
        {
            selector: ".js-swiper-carousel-slot",
            getWrapperClass: () => ".ahumada-recommendation-carousel-wrapper",
            getContainerSelector: () => ".ahumada-recommendation-carousel-swiper",
            afterInit: () => {
                var { initPopover } = require("../../js/utils/popoverUtils");
                initPopover();
            }
        }
    ];

    configs.forEach(cfg => {
        const carousels = $(cfg.selector).not(`[${initializedAttr}]`);
        carousels.each(function () {
            const $swiperWrapper = $(this);
            const initializeSwiperCarousel = () => {
                const swipperWrapperClass = cfg.getWrapperClass($swiperWrapper);
                const swiperContainerSelector = cfg.getContainerSelector(swipperWrapperClass);

                let slidesToShow, slidesToShowMobile, spacing;
                try {
                    slidesToShow = parseInt($swiperWrapper.data("slides-to-show"), 10) || 5;
                    slidesToShowMobile = parseInt($swiperWrapper.data("slides-to-show-mobile"), 10) || 2;
                    spacing = parseInt($swiperWrapper.data("spacing"), 10) || 16;
                } catch (e) {
                    slidesToShow = 5;
                    slidesToShowMobile = 2;
                    spacing = 16;
                }

                const paginationEnabled = $swiperWrapper.data("pagination-enabled");
                const loopEnabled = $swiperWrapper.data("loop-enabled");
                const navEnabled = $swiperWrapper.data("navigation-enabled");
                const scrollbarEnabled = $swiperWrapper.data("scroll-enabled");
                const direction = $swiperWrapper.data("direction");
                const clickableSlide = !!$swiperWrapper.data("clickable-slide");
                const syncedCarouselId = $swiperWrapper.data("sync-carousel-id");
                const carouselModules = [];

                if (navEnabled) {
                    carouselModules.push(Navigation);
                }

                if (paginationEnabled) {
                    carouselModules.push(Pagination);
                }

                if (scrollbarEnabled) {
                    carouselModules.push(Scrollbar);
                }

                if (syncedCarouselId) {
                    carouselModules.push(Thumbs);
                }

                const carouselOptions = {
                    loop: Boolean(loopEnabled),
                    modules: carouselModules,
                    direction: direction || "horizontal",
                    pagination: {
                        el: `${swipperWrapperClass} .js-swiper-pagination`,
                        type: "bullets",
                        clickable: true,
                    },
                    navigation: {
                        nextEl: `${swipperWrapperClass} .js-swiper-button-next`,
                        prevEl: `${swipperWrapperClass} .js-swiper-button-prev`,
                    },
                    scrollbar: {
                        el: `${swipperWrapperClass} .js-swiper-scrollbar`,
                    },
                    slideToClickedSlide: clickableSlide,
                    slidesPerView: slidesToShowMobile,
                    spaceBetween: spacing,
                    breakpoints: {
                        1024: {
                            slidesPerView: slidesToShow,
                            spaceBetween: spacing,
                        },
                    }
                };

                // If .js-swiper-carousel, add thumbs if needed
                if (cfg.selector === ".js-swiper-carousel" && syncedCarouselId) {
                    const thumbnailCarouselElement = $(".image-carrousel__thumbnails").find(".swiper")[0];
                    const thumbnailSwiper = thumbnailCarouselElement ? thumbnailCarouselElement.swiper : null;
                    if (thumbnailSwiper) {
                        carouselOptions.thumbs = { swiper: thumbnailSwiper };
                    }
                }

                // eslint-disable-next-line no-unused-vars
                const carouselSwiper = new Swiper(swiperContainerSelector, carouselOptions);

                if (typeof cfg.afterInit === "function") {
                    cfg.afterInit();
                }
            };
            if (cfg.selector === ".js-swiper-carousel-slot") {
                $swiperWrapper.attr(initializedAttr, "true");
                setTimeout(initializeSwiperCarousel, 1000);
            } else {
                $swiperWrapper.attr(initializedAttr, "true");
                initializeSwiperCarousel();
            }
        });
    });
}

window.addEventListener("load", () => {
    if (!window.swiperCarouselInitialized) {
        initSwipers();
        window.swiperCarouselInitialized = true;
    }
});

// MutationObserver for dynamic carousels - EINSTEIN - only react to .js-swiper-carousel-slot additions
const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        for (const node of mutation.addedNodes) {
            if (
                node.nodeType === 1 && (
                    node.classList?.contains("js-swiper-carousel-slot") ||
                    node.querySelector?.(".js-swiper-carousel-slot")
                )
            ) {
                initSwipers();
                return;
            }
        }
    }
});
observer.observe(document.body, { childList: true, subtree: true });
